/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Notfounddescription2Inputs */

const id_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox tidak ditemukan`)
};

const ms_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox tidak ditemui`)
};

const da_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox ikke fundet`)
};

const de_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox nicht gefunden`)
};

const en_us2_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox not found`)
};

const es_es2_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox no encontrado`)
};

const es_mx2_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox no encontrado`)
};

const fil_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi nahanap ang Sandbox`)
};

const fr_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox non trouvé`)
};

const it_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox non trovato`)
};

const hu_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox nem található`)
};

const nl_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox niet gevonden`)
};

const no_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox ikke funnet`)
};

const pl_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox nie znaleziony`)
};

const pt_br2_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox não encontrado`)
};

const pt_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox não encontrada`)
};

const ro_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox negăsit`)
};

const fi_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiekkalaatikkoa ei löydy`)
};

const sv_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandlådan hittades inte`)
};

const vi_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy Sandbox`)
};

const tr_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox bulunamadı`)
};

const cs_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox nenalezen`)
};

const bg_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox не е намерен`)
};

const ru_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Песочница не найдена`)
};

const uk_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox не знайдено`)
};

const ar_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على Sandbox`)
};

const hi_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सैंडबॉक्स नहीं मिला`)
};

const th_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบแซนด์บ็อกซ์`)
};

const ja_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンドボックスが見つかりません`)
};

const zh_cn2_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沙盒未找到`)
};

const zh_hant1_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沙盒未找到`)
};

const ko_sandboxes_notfounddescription2 = /** @type {(inputs: Sandboxes_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox를 찾을 수 없음`)
};

/**
* | output |
* | --- |
* | "Sandbox not found" |
*
* @param {Sandboxes_Notfounddescription2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_notfounddescription2 = /** @type {((inputs?: Sandboxes_Notfounddescription2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Notfounddescription2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_notfounddescription2(inputs)
	if (locale === "ms") return ms_sandboxes_notfounddescription2(inputs)
	if (locale === "da") return da_sandboxes_notfounddescription2(inputs)
	if (locale === "de") return de_sandboxes_notfounddescription2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_notfounddescription2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_notfounddescription2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_notfounddescription2(inputs)
	if (locale === "fil") return fil_sandboxes_notfounddescription2(inputs)
	if (locale === "fr") return fr_sandboxes_notfounddescription2(inputs)
	if (locale === "it") return it_sandboxes_notfounddescription2(inputs)
	if (locale === "hu") return hu_sandboxes_notfounddescription2(inputs)
	if (locale === "nl") return nl_sandboxes_notfounddescription2(inputs)
	if (locale === "no") return no_sandboxes_notfounddescription2(inputs)
	if (locale === "pl") return pl_sandboxes_notfounddescription2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_notfounddescription2(inputs)
	if (locale === "pt") return pt_sandboxes_notfounddescription2(inputs)
	if (locale === "ro") return ro_sandboxes_notfounddescription2(inputs)
	if (locale === "fi") return fi_sandboxes_notfounddescription2(inputs)
	if (locale === "sv") return sv_sandboxes_notfounddescription2(inputs)
	if (locale === "vi") return vi_sandboxes_notfounddescription2(inputs)
	if (locale === "tr") return tr_sandboxes_notfounddescription2(inputs)
	if (locale === "cs") return cs_sandboxes_notfounddescription2(inputs)
	if (locale === "bg") return bg_sandboxes_notfounddescription2(inputs)
	if (locale === "ru") return ru_sandboxes_notfounddescription2(inputs)
	if (locale === "uk") return uk_sandboxes_notfounddescription2(inputs)
	if (locale === "ar") return ar_sandboxes_notfounddescription2(inputs)
	if (locale === "hi") return hi_sandboxes_notfounddescription2(inputs)
	if (locale === "th") return th_sandboxes_notfounddescription2(inputs)
	if (locale === "ja") return ja_sandboxes_notfounddescription2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_notfounddescription2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_notfounddescription2(inputs)
	return ko_sandboxes_notfounddescription2(inputs)
});
export { sandboxes_notfounddescription2 as "sandboxes.notFoundDescription" }